import { useComputed } from '@preact/signals-react';
import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

function ConfirmationTaskModal({ show, handleCancel, handleConfirm, selectedTasks }) {

    const canSubmitSignal = useComputed(() => {
        const taskStatuses = selectedTasks.value.map(task => task.TaskStatus)
        // Task status must be greater than Requested (0) and less than Scheduled (15)
        return taskStatuses.every(taskStatus => taskStatus >= 0 && taskStatus < 15)
    })

    return (
        <Modal
            show={show}
            onHide={handleCancel}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton>
                <Modal.Title>Delete Tasks</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p hidden={!canSubmitSignal.value}>{selectedTasks.value.length} task(s) will be deleted. Are you sure you want to continue?</p>
                <p hidden={canSubmitSignal.value}>Unable to delete tasks that are in process or complete.</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleCancel}>Cancel</Button>
                <Button variant="danger" hidden={!canSubmitSignal.value} onClick={handleConfirm}>Confirm</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ConfirmationTaskModal;

